<template>
  <div class="Header">
    <div class="header_dashboard">
      <div class="logo-box">
        <img src="../assets/images/logo@2x.png" />
        <h3>{{$t('star')}} 91</h3>
      </div>

      <!-- <div class="img-box" @click="iconClick"> -->
      <span class="prf-img">
        <!-- <img src="../assets/images/user_images.png"  /> -->
        <img :src="profile_pic" v-if="profile_pic"/>
        <img src="../assets/images/user_images.png" v-else />
      </span>

      <!-- <span class="goBack_icon">
          {{update_profile_txt}}
          <i class="material-icons">{{icon_txt}}</i>
        </span>
        
      </div>-->
    </div>
  </div>
</template>
<script>
import VueCookie from "vue-cookie";
export default {
  name: "Button",
  props: {
    update_profile_txt: {
      required: true,
      type: String
    },
    icon_txt: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      profile_pic: JSON.parse(VueCookie.get("user"))
        ? JSON.parse(VueCookie.get("user")).profile_pic
        : ""
    };
  },
  methods: {
    iconClick() {
      this.$emit("goToProfileCallback");
      this.$emit("uploadPicCallback");
    }
  }
};
</script>